var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Icon } from "../../UI";


import { Translate } from "../../I18N";






const updateIndeterminate = (item) => (elem) => {
  if (item.selectAll && elem && item.indeterminate !== undefined) {
    // eslint-disable-next-line no-param-reassign
    elem.indeterminate = item.indeterminate;
  }
};

const ColumnItem = ({ item }) => /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
React.createElement("input", {
  ref: updateIndeterminate(item),
  type: "checkbox",
  checked: !item.hidden,
  onChange: () => {} }
), /*#__PURE__*/
_jsx(Translate, { context: item.translationContext }, void 0, item.label)
);


const ValueItem =
(hiddenColumns, isOpen, closeFunction) => () => /*#__PURE__*/
_jsx("span", { className: "columns-hint", onClick: closeFunction }, void 0,
isOpen ? /*#__PURE__*/_jsx(Icon, { icon: "times" }) : /*#__PURE__*/_jsx(Icon, { icon: "bars", rotation: 90 }),
hiddenColumns.length ? `${hiddenColumns.length} ` : '', /*#__PURE__*/
_jsx(Translate, {}, void 0, hiddenColumns.length ? 'columns hidden' : 'Hide columns')
);



export { ColumnItem, ValueItem };